import {
  Button,
  Checkbox,
  Divider,
  Form,
  InputNumber,
  Select,
  Steps,
} from "antd";
import { useEffect, useState } from "react";
import "../../MigrationRules.css";
import {
  CheckOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import TablesService from "../../../../../../services/tables/TablesService";
import { GetTablesRequest } from "../../../../../../models/tables/GetTablesRequest";
import RuleConditions from "../RuleConditions";
import { CreateMigrationRuleMapping } from "../../../../../../models/migrationrules/CreateMigrationRuleMapping";
import { useTranslation } from "react-i18next";

const { Step } = Steps;

const CopyRuleOverview = ({
  selectedEntity,
  selectedGroupCode,
  setCopyRuleOverviewDialogMode,
}: {
  copyRuleOverviewDialogMode: boolean;
  setCopyRuleOverviewDialogMode: (val: boolean) => void;
  selectedEntity: any;
  selectedGroupCode: any;
  setTriggerUpdate: any;
}) => {
  const { t, i18n } = useTranslation("translations");
  const [current, setCurrent] = useState(0);

  const [fromTables, setFromTables] = useState<any>([]);
  const [destinationTables, setDestinationTables] = useState<any>([]);
  const [selectedFromTable, setSelectedFromTable] = useState<any>(null);
  const [selectedDestinationTable, setSelectedDestinationTable] =
    useState<any>(null);
  const [ruleValuesData, setRuleValuesData] = useState<any>([]);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [ruleValuesDestinationTable, setRuleValuesDestinationTable] =
    useState<any>(null);
  const [selectedRuleValueRows, setSelectedRuleValueRows] = useState<any>([]);
  const [newRuleValueModalEnabled, setNewRuleValueModalEnabled] =
    useState(false);
  const [newConditionModalEnabled, setNewConditionModalEnabled] =
    useState(false);
  const [selectedConditionRows, setSelectedConditionRows] = useState<any>([]);
  const [selectedMigrationStatus, setSelectedMigrationStatus] = useState<any>();
  const [weightInput, setWeightInput] = useState<any>();
  const [isActive, setIsActive] = useState<any>(true);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onCloseSteps = () => {
    setCopyRuleOverviewDialogMode(false);
  };

  useEffect(() => {
    const toModel: GetTablesRequest = {
      entityId: 0,
      operationId: 0,
      groupCode: selectedGroupCode,
    };
    TablesService.getTables(toModel).then((response: any) => {
      const data = response.data;
      if (data && data !== undefined && data.length > 0) {
        setDestinationTables(data);
      }
    });
  }, [selectedGroupCode]);

  useEffect(() => {
    if (selectedEntity && selectedGroupCode) {
      const model: GetTablesRequest = {
        entityId: selectedEntity,
        operationId: 1,
        groupCode: selectedGroupCode,
      };

      TablesService.getTables(model).then((response) => {
        setFromTables(response.data);
      });
    }
  }, [selectedEntity, selectedGroupCode]);

  const steps = [
    {
      title: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectSource",
        {
          lngs: i18n.languages,
          defaultValue: "Select source",
        }
      ),
      content: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSourceDataset",
        {
          lngs: i18n.languages,
          defaultValue: "Source dataset",
        }
      ),
    },
    {
      title: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectDestination",
        {
          lngs: i18n.languages,
          defaultValue: "Select destination",
        }
      ),
      content: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperDestination",
        {
          lngs: i18n.languages,
          defaultValue: "Destination",
        }
      ),
    },
    {
      title: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectMappings",
        {
          lngs: i18n.languages,
          defaultValue: "Select mappings",
        }
      ),
      content: t(
        "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectMappingsToCopy",
        {
          lngs: i18n.languages,
          defaultValue: "Select mappings to copy",
        }
      ),
    },
  ];

  const onFromTableChange = (value: string) => {
    setSelectedFromTable(value);
  };
  const handleMigrationStatusChange = (value: string) => {
    setSelectedMigrationStatus(value);
  };
  const handleWeightChange = (value: number) => {
    setWeightInput(value);
  };
  const onStepChange = (value: number) => {
    setCurrent(value);
  };

  return (
    <div className="body-container">
      <div className="steps-container">
        <Steps
          direction="vertical"
          size="small"
          initial={0}
          current={current}
          onChange={onStepChange}
        >
          {steps.map((item) => (
            <Step
              key={item.title}
              title={item.title}
              description={item.content}
            />
          ))}
        </Steps>
      </div>
      <div className="overview-form-container">
        <div className="title-actions">
          <div>
            {current === 0 && (
              <span style={{ fontSize: "16px" }}>
                <b>
                  {t(
                    "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectSource",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Select source",
                    }
                  )}
                </b>
              </span>
            )}
            {current === 1 && (
              <span style={{ fontSize: "16px" }}>
                <b>
                  {t(
                    "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectDestination",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Select destination",
                    }
                  )}
                </b>
              </span>
            )}
            {current === 2 && (
              <span style={{ fontSize: "16px" }}>
                <b>
                  {t(
                    "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.CopyStepperSelectMappings",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Select mappings",
                    }
                  )}
                </b>
              </span>
            )}
          </div>
          <div className="action-buttons">
            <Button
              onClick={() => prev()}
              type={current === 0 ? "default" : "ghost"}
              size="small"
              icon={<ArrowLeftOutlined />}
              disabled={current === 0}
            >
              {t("General.Labels.Back", {
                lngs: i18n.languages,
                defaultValue: "Back",
              })}
            </Button>
            {current === 2 && (
              <Button
                // onClick={() => addMapping()}
                type="primary"
                className="active-btn"
                size="small"
                icon={<CheckOutlined />}
                // disabled={current < 4}
              >
                {t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.AddMapping",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Add mapping",
                  }
                )}
              </Button>
            )}
            {current < 2 && (
              <Button
                onClick={() => next()}
                type={
                  current === 1 && !selectedEntity
                    ? // (current === 1 && !selectedGroupCode) ||

                      // (current === 2 && !selectedFromTable)
                      "default"
                    : "ghost"
                }
                size="small"
                icon={<ArrowRightOutlined />}
              >
                {t("General.Labels.Next", {
                  lngs: i18n.languages,
                  defaultValue: "Next",
                })}
              </Button>
            )}

            <Button
              type="ghost"
              onClick={onCloseSteps}
              icon={<CloseOutlined />}
              size="small"
            />
          </div>
        </div>
        <Divider />
        <div>
          {current === 0 && (
            <Form layout="vertical" wrapperCol={{ span: 8 }}>
              <Form.Item
                // className={styles.mb10px}
                label={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.FromTable",
                  {
                    lngs: i18n.languages,
                    defaultValue: "From table",
                  }
                )}
                required
                tooltip={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Tooltips.FromTable",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  disabled={current !== 0}
                  value={selectedFromTable}
                  options={fromTables.map((x: any) => ({
                    label: x.name,
                    value: x.id,
                  }))}
                  onChange={onFromTableChange}
                ></Select>
              </Form.Item>
            </Form>
          )}
          {current === 1 && (
            <Form layout="vertical" wrapperCol={{ span: 8 }}>
              <Form.Item
                // className={styles.mb10px}
                label={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.DestinationTable",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Destination Table",
                  }
                )}
                required
                tooltip={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Tooltips.DestinationTable",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  disabled={current !== 1}
                  value={selectedDestinationTable}
                  options={destinationTables.map((x: any) => ({
                    label: x.name,
                    value: x.id,
                  }))}
                  onChange={onFromTableChange}
                ></Select>
              </Form.Item>
            </Form>
          )}
          {current === 2 && (
            <div>
              <RuleConditions
                newConditionModalEnabled={newConditionModalEnabled}
                setNewConditionModalEnabled={setNewConditionModalEnabled}
                selectable={true}
                multiSelect={false}
                selectedRows={selectedConditionRows}
                setSelectedRows={setSelectedConditionRows}
              />
            </div>
          )}
          {current === 3 && (
            <Form layout="vertical" wrapperCol={{ span: 8 }}>
              <Form.Item
                // className={styles.mb10px}
                label={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.Weight",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Weight",
                  }
                )}
                required
                tooltip={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Tooltips.Weight",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <InputNumber
                  value={weightInput}
                  onChange={handleWeightChange}
                  min={1}
                  placeholder={
                    t("General.Placeholders.EnterValue", {
                      lngs: i18n.languages,
                      defaultValue: "Enter value",
                    })!
                  }
                />
              </Form.Item>
              <Form.Item
                // className={styles.mb10px}
                label={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Table.Headers.MigrationStatus",
                  {
                    lngs: i18n.languages,
                    defaultValue: "Migration status",
                  }
                )}
                required
                tooltip={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Tooltips.MigrationStatus",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Select
                  placeholder={t("General.Placeholders.SelectOption", {
                    lngs: i18n.languages,
                    defaultValue: "Select option",
                  })}
                  allowClear
                  disabled={current !== 3}
                  options={[
                    {
                      label: t(
                        "Page.Operation.MigrationRules.Tabs.RuleOverview.Label.Migration",
                        {
                          lngs: i18n.languages,
                          defaultValue: "MIGRATION",
                        }
                      ),
                      value: "MIGRATION",
                    },
                    {
                      label: t(
                        "Page.Operation.MigrationRules.Tabs.RuleOverview.Label.NoMigration",
                        {
                          lngs: i18n.languages,
                          defaultValue: "NO MIGRATION",
                        }
                      ),
                      value: "NO MIGRATION",
                    },
                  ]}
                  value={selectedMigrationStatus}
                  onChange={handleMigrationStatusChange}
                ></Select>
              </Form.Item>
              <Form.Item
                // className={styles.mb10px}
                required
                tooltip={t(
                  "Page.Operation.MigrationRules.Tabs.RuleOverview.Tooltips.FromTable",
                  {
                    lngs: i18n.languages,
                    defaultValue: "",
                  }
                )}
              >
                <Checkbox
                  checked={isActive}
                  onClick={() => setIsActive(!isActive)}
                >
                  {t(
                    "Page.Operation.MigrationRules.Tabs.RuleOverview.Labels.IsActive",
                    {
                      lngs: i18n.languages,
                      defaultValue: "Is Active",
                    }
                  )}
                </Checkbox>
              </Form.Item>
            </Form>
          )}
          {current === 4 && (
            <>
              <div className="overview-section">
                <span>Selected sources</span>
                <table>
                  <tr>
                    <td>Group Code</td>
                    <td>{selectedGroupCode}</td>
                  </tr>
                  <tr>
                    <td>Entity</td>
                    <td>{selectedEntity}</td>
                  </tr>
                  <tr>
                    <td>From Table</td>
                    <td>
                      {
                        fromTables.find((x: any) => x.id === selectedFromTable)
                          .name
                      }
                    </td>
                  </tr>
                </table>
              </div>
              <div className="overview-section">
                <span>Selected rule</span>
                <table>
                  <tr>
                    <td>Rule ID</td>
                    <td>
                      {selectedRuleValueRows?.length > 0
                        ? selectedRuleValueRows[0].id
                        : "Not selected"}
                    </td>
                  </tr>
                  <tr>
                    <td>Rule Name</td>
                    <td>
                      {selectedRuleValueRows?.length > 0
                        ? selectedRuleValueRows[0].ruleName
                        : "Not selected"}
                    </td>
                  </tr>
                  <tr>
                    <td>Rule Description</td>
                    <td>
                      {selectedRuleValueRows?.length > 0
                        ? selectedRuleValueRows[0].ruleDescription
                        : "Not selected"}
                    </td>
                  </tr>
                  <tr>
                    <td>Value</td>
                    <td>
                      {selectedRuleValueRows?.length > 0
                        ? selectedRuleValueRows[0].valueColumn
                        : "Not selected"}
                    </td>
                  </tr>
                  <tr>
                    <td>Join</td>
                    <td>
                      {selectedRuleValueRows?.length > 0
                        ? selectedRuleValueRows[0].joinCondition
                        : "Not selected"}
                    </td>
                  </tr>
                </table>
              </div>
              <div className="overview-section">
                <span>Selected Condition</span>
                <table>
                  <tr>
                    <td>Condition</td>
                    <td>
                      {selectedConditionRows?.length > 0
                        ? selectedConditionRows[0].value
                        : "Not selected"}
                    </td>
                  </tr>
                </table>
              </div>
              <div className="overview-section">
                <span>Mapping Data</span>
                <table>
                  <tr>
                    <td>Weight</td>
                    <td>{weightInput}</td>
                  </tr>
                  <tr>
                    <td>Migration Status</td>
                    <td>{selectedMigrationStatus}</td>
                  </tr>
                  <tr>
                    <td>Is Active</td>
                    <td>{isActive}</td>
                  </tr>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CopyRuleOverview;
